module.exports = __webpack_public_path__ + "static/img/4.eb32bcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/4.png
// module id = dDoC
// module chunks = 0